import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
    id: "login",
    class: "auth"
};
var _hoisted_2 = { class: "row justify-content-center" };
var _hoisted_3 = { class: "col-lg-6" };
var _hoisted_4 = { class: "card" };
var _hoisted_5 = { class: "card-body py-4" };
var _hoisted_6 = { class: "input-group" };
var _hoisted_7 = { class: "input-group mt-3" };
var _hoisted_8 = {
    key: 1,
    class: "text-danger"
};
var _hoisted_9 = { class: "input-group mt-3" };
var _hoisted_10 = ["type"];
var _hoisted_11 = { class: "input-group mt-3" };
var _hoisted_12 = ["type"];
var _hoisted_13 = { class: "input-group mt-3" };
var _hoisted_14 = { class: "row justify-content-center px-4 pt-3" };
var _hoisted_15 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
    var _component_CountrySelect = _resolveComponent("CountrySelect");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[10] || (_cache[10] = _createElementVNode("h2", { class: "text-center" }, "Crea tu cuenta", -1)),
                        _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-center text-white" }, "Empieza a administrar tus espacios compartidos", -1)),
                        _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_ctx.register.email) = $event); }),
                                placeholder: "Correo electrónico",
                                onInput: _cache[1] || (_cache[1] =
                                    //@ts-ignore
                                    function () {
                                        var args = [];
                                        for (var _i = 0; _i < arguments.length; _i++) {
                                            args[_i] = arguments[_i];
                                        }
                                        return (_ctx.validateEmail && _ctx.validateEmail.apply(_ctx, args));
                                    })
                            }, null, 544), [
                                [_vModelText, _ctx.register.email]
                            ])
                        ]),
                        (_ctx.emailError)
                            ? (_openBlock(), _createElementBlock("small", {
                                key: 0,
                                style: _normalizeStyle({ color: _ctx.colorLevel })
                            }, _toDisplayString(_ctx.emailError), 5))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_7, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((_ctx.register.username) = $event); }),
                                placeholder: "Nombre de usuario",
                                onInput: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    function () {
                                        var args = [];
                                        for (var _i = 0; _i < arguments.length; _i++) {
                                            args[_i] = arguments[_i];
                                        }
                                        return (_ctx.validateUsername && _ctx.validateUsername.apply(_ctx, args));
                                    })
                            }, null, 544), [
                                [_vModelText, _ctx.register.username]
                            ])
                        ]),
                        (_ctx.usernameError)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_8, _toDisplayString(_ctx.usernameError), 1))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_9, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((_ctx.register.password) = $event); }),
                                placeholder: "Contraseña",
                                type: _ctx.seePass ? 'text' : 'password'
                            }, null, 8, _hoisted_10), [
                                [_vModelDynamic, _ctx.register.password]
                            ]),
                            _createElementVNode("button", {
                                class: "btn btn-outline-secondary",
                                type: "button",
                                onClick: _cache[5] || (_cache[5] = function ($event) { return (_ctx.seePass = !_ctx.seePass); })
                            }, [
                                _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', _ctx.seePass ? 'eye' : 'fa-eye-slash']
                                }, null, 8, ["icon"])
                            ])
                        ]),
                        (_ctx.register.password)
                            ? (_openBlock(), _createElementBlock("small", {
                                key: 2,
                                style: _normalizeStyle({ color: _ctx.colorLevel })
                            }, "Seguridad: " + _toDisplayString(_ctx.passwordLevel), 5))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_11, [
                            _withDirectives(_createElementVNode("input", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) { return ((_ctx.register.confirmPassword) = $event); }),
                                placeholder: "Confirmar contraseña",
                                type: _ctx.seeRep ? 'text' : 'password'
                            }, null, 8, _hoisted_12), [
                                [_vModelDynamic, _ctx.register.confirmPassword]
                            ]),
                            _createElementVNode("button", {
                                class: "btn btn-outline-secondary",
                                type: "button",
                                onClick: _cache[7] || (_cache[7] = function ($event) { return (_ctx.seeRep = !_ctx.seeRep); })
                            }, [
                                _createVNode(_component_font_awesome_icon, {
                                    icon: ['fas', _ctx.seeRep ? 'eye' : 'fa-eye-slash']
                                }, null, 8, ["icon"])
                            ])
                        ]),
                        (_ctx.register.confirmPassword)
                            ? (_openBlock(), _createElementBlock("small", {
                                key: 3,
                                style: _normalizeStyle({ color: _ctx.register.password === _ctx.register.confirmPassword ? 'green' : 'red' })
                            }, _toDisplayString(_ctx.register.password === _ctx.register.confirmPassword && _ctx.register.confirmPassword.length > 0 ? 'Las contraseñas coinciden' : 'Las contraseñas no coinciden'), 5))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_13, [
                            _createVNode(_component_CountrySelect, {
                                modelValue: _ctx.register.country,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((_ctx.register.country) = $event); })
                            }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                                class: "btn btn-secondary",
                                disabled: !_ctx.enableButton,
                                onClick: _cache[9] || (_cache[9] =
                                    //@ts-ignore
                                    function () {
                                        var args = [];
                                        for (var _i = 0; _i < arguments.length; _i++) {
                                            args[_i] = arguments[_i];
                                        }
                                        return (_ctx.handleRegister && _ctx.handleRegister.apply(_ctx, args));
                                    })
                            }, "Registrar", 8, _hoisted_15)
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
